<template>
  <div class="modal">
    <Loading v-if="loading" />
    <!--
      Second View With Side View
    <div class="header">
      <p>{{ restaurantDetails.name }}</p>
    </div>
    -->
    <div class="modal-content">
      <div class="header">
        <p>{{ restaurantDetails.name }}</p>
      </div>
      <div class="menu">
        <RestaurantItem
          :key="index"
          v-for="(menu, index) in restaurantDetails.itemNames"
          :restaurantDetails="restaurantDetails"
          :itemName="restaurantDetails.itemNames[index]"
          :itemValue="restaurantDetails.itemValues[index]"
          :mainCart="mainCart"
          @item-updated="updateCart"
        />
      </div>
      <div class="close-or-proceed">
        <div class="close-btn">
          <button class="close-button" @click.prevent="closeModal">
            Close
          </button>
        </div>
        <div class="proceed-btn">
          <button class="proceed-button" @click.prevent="proceedToCart">
            Finalised!
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RestaurantItem from "./RestaurantItem.vue";
import Loading from "./Loading.vue";

export default {
  name: "RestaurantModal",
  data() {
    return {
      loading: false,
      mainCart: this.$store.state.profileCart,
      // I think store.state is using something similar to pass by reference, confirm with Sarah
      //mainCart: [],
    };
  },
  components: {
    RestaurantItem,
    Loading,
  },
  props: ["restaurantDetails"],
  methods: {
    async proceedToCart() {
      this.loading = true;
      await this.$store.dispatch("updateCart");
      this.loading = false;
      this.$router.push({ name: "Cart" });
    },
    async closeModal() {
      this.$store.dispatch("updateCart");
      await this.$emit("close-restaurant-modal");
    },
    updateCart(itemToBeUpdated) {
      /**
       * 0 position in itemToBeUpdated is for Item Name
       * 1 position in itemToBeUpdated is for Item Value
       * 2 position in itemToBeUpdated is for Item Quantity
       */
      // Try Accessing the cart stored in db for the view and restaurant clash issue!
      if (this.mainCart === null || this.mainCart.length === 0) {
        //this.mainCart = [];
        this.mainCart[0] = this.restaurantDetails.id;
        this.mainCart[1] = itemToBeUpdated[0];
        this.mainCart[2] = itemToBeUpdated[1];
        this.mainCart[3] = itemToBeUpdated[2];
      } else if (this.mainCart[0] !== this.restaurantDetails.id) {
        // Ask User in a modal if he wants to add this item and remove the others ? or else he can cancel that and leave the cart as it is.
        this.$toast.warning(
          "Mixing Items From Two Different Restaurants? It is our dream too! But alas, The Algorithm Won't Allow!"
        );
        return;
      } else {
        let updatedCart = false;
        for (let i = 1; i < this.mainCart.length; i = i + 3) {
          if (this.mainCart[i] === itemToBeUpdated[0]) {
            updatedCart = true;
            if (itemToBeUpdated[2] === 0) {
              this.mainCart.splice(i, 3);
              if (this.mainCart.length === 1) {
                //this.mainCart = [];
                this.mainCart.splice(0, this.mainCart.length);
              }
            } else {
              this.mainCart[i + 2] = itemToBeUpdated[2];
            }
          }
        }

        if (!updatedCart) {
          const nextPositionToFill = this.mainCart.length;
          this.mainCart[nextPositionToFill] = itemToBeUpdated[0];
          this.mainCart[nextPositionToFill + 1] = itemToBeUpdated[1];
          this.mainCart[nextPositionToFill + 2] = itemToBeUpdated[2];
        }
      }

      // TO DO, UPDATE CART to FIREBASE
      console.log(this.mainCart);
    },
  },
};
</script>

<style lang="scss" scoped>
.modal {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 101;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  background-color: rgba(0, 0, 0, 0.7);

  /*
  // Second View With Side View
  .header {
    display: flex;
    background-color: rgb(211, 200, 142);
    width: 25%;
    height: 90%;
    border-radius: 8px 0 0 8px;
    justify-content: center;
    margin-left: 50px;
    p {
      text-align: center;
      font-size: 40px;
      font-weight: 400;
    }
  }
  */

  .modal-content {
    overflow: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-radius: 8px;
    //300px
    width: 90%;
    height: 90%;
    padding: 40px 30px;
    background-color: #fff;
    //margin-right: 50px;

    p {
      text-align: center;
      font-size: 40px;
      font-weight: 400;
    }
    /*
    button {
      align-self: center;
      background-color: rgb(255, 0, 60);
      border: 2px red solid;
      cursor: pointer;
    }
*/
    .header {
      //display: flex;
      //flex-direction: column;
      flex-basis: 10%;
    }

    .menu {
      overflow: auto;
      flex-basis: 90%;

      &::-webkit-scrollbar {
        display: none;
      }
    }

    .close-or-proceed {
      flex-basis: 5%;
      //margin: 0 auto;
      display: flex;
      flex-direction: row;

      /*
      // Good for Center Alignment
      display: flex;
      justify-content: center;
      */
      //align-items: center;

      // Aligning centre
      .close-btn {
        flex-basis: 50%;
        //width: 500px;
        display: flex;
        justify-content: center;

        .close-button {
          align-self: center;
          background-color: rgb(255, 0, 60);
          border: 2px red solid;
          cursor: pointer;
        }
      }
      .proceed-btn {
        flex-basis: 50%;
        display: flex;
        justify-content: center;

        .proceed-button {
          //background-color: rgb(40, 0, 85);
          //border: 2px solid rgb(40, 0, 85);
          cursor: pointer;
          //margin: inherit 0 0 auto;
          //display: none;
        }
      }
    }
  }
}

/*
// To Disable Scroll Bar, HEHE
.menu::-webkit-scrollbar {
  display: none;
}
*/
</style>
